import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const clearVehiclesEfficiency = () => ({
  'type': ActionTypes.CLEAR_VEHICLES_EFFICIENCY,
});

export const fecthVehiclesEfficiency = (queryString) => {
  const saleType = queryString.saleType ? `&saleType=${queryString.saleType}` : '';
  const startDate = queryString.startDate ? `&startDate=${queryString.startDate}` : '';
  const endDate = queryString.endDate ? `&endDate=${queryString.endDate}` : '';
  const dateType = queryString.dateType ? `&dateType=${queryString.dateType}` : '';
  const chassis = queryString.chassis ? `&chassis=${queryString.chassis}` : '';
  const reservedTo = queryString.reservedTo ? `&reservedTo=${queryString.reservedTo}` : '';

  const allFilters = `${saleType}${startDate}${endDate}${dateType}${chassis}${reservedTo}`;

  return apiActionCreator({
    'endpoint': `/vehicles/efficiency?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_EFFICIENCY,
      ActionTypes.FETCHED_VEHICLES_EFFICIENCY,
      [
        ActionTypes.FETCHED_VEHICLES_EFFICIENCY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const clearChassisInfo = () => ({
  'type': ActionTypes.CLEAR_CHASSIS_INFO,
});

export const downloadVehiclesEfficiency = (queryString) => {
  const saleType = queryString.saleType ? `&saleType=${queryString.saleType}` : '';
  const startDate = queryString.startDate ? `&startDate=${queryString.startDate}` : '';
  const endDate = queryString.endDate ? `&endDate=${queryString.endDate}` : '';
  const dateType = queryString.dateType ? `&dateType=${queryString.dateType}` : '';
  const chassis = queryString.chassis ? `&chassis=${queryString.chassis}` : '';
  const reservedTo = queryString.reservedTo ? `&reservedTo=${queryString.reservedTo}` : '';

  const allFilters = `${saleType}${startDate}${endDate}${dateType}${chassis}${reservedTo}`;

  return apiActionCreator({
    'endpoint': `/vehicles/efficiency/excel?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_VEHICLES_EFFICIENCY,
      ActionTypes.DOWNLOADED_VEHICLES_EFFICIENCY,
      [
        ActionTypes.DOWNLOADED_VEHICLES_EFFICIENCY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const clearUrlVehiclesEfficiency = () => ({
  'type': ActionTypes.CLEAR_URL_VEHICLES_EFFICIENCY,
});
